import React from "react";
import platePatternUtils from "../../../../../utils/plate-pattern-utils.js";

const ReportContent = ({ data, showDescription, tableColumns }) => {
    const columns = [
        {id: "dt_action", label: "D/H da ação", className: "w-[8%]", renderCell: cortex => cortex.dt_action ?? ""},
        {id: "plate", label: "Placa", className: "w-[5%]", renderCell: cortex => platePatternUtils.formatPlate(cortex.plate)},
        {id: "reason", label: "Ação", className: "w-[10%]", renderCell: cortex => cortex.reason ?? ""},
        {id: "occurrence_id", label: "ID da Ocorrência Sentry", className: "w-[10%]", renderCell: cortex => cortex.occurrence_id || cortex.alarm_id || ""},
        {id: "user", label: "Agente", className: "w-[10%]", renderCell: cortex => cortex.user ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>
            ) : (
            <table className="table report-table">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left font-bold">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>

                <tbody>
                    {data.map((cortex, index) => (
                        <React.Fragment key={index}>
                            <tr className={`${showDescription ? 'details-row' : ''}`}>
                                {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(cortex)}</td>)}
                            </tr>

                            {showDescription && cortex.description && (
                                <tr>
                                    <td colSpan={visibleColumns.length} style={{ borderBottom: "0 transparent" }}> {cortex.description} </td>
                                </tr>
                            )}

                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            )}
        </>
    );
};

export default ReportContent;